import BaseApp from "../BaseApp";
import UIModal from "../../classes/modals/UIModal";

export default class ExpiredTokenWatcherApp extends BaseApp {
    onReady() {
        system.socketClient.subscribeTo(
            "token_expired",
            this.onTryTokenExpired.bind(this)
        );
    }

    async onTryTokenExpired() {
        try {
            await this.onTokenExpired();
        } catch (error) {
            console.error("Error:", error);
        }
    }

    async onTokenExpired() {
        const mainUrl = new URL(window.location.href).origin;
        const cookieAuthClearUrl = `${mainUrl}/cookies-auth/clear`;
        const response = await fetch(cookieAuthClearUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if ( response.ok ) {
            this.showLogoutMessage();
        }
    }

    showLogoutMessage() {
        UIModal.error({
            text: "logos_logout",
            okText: "login",
            buttons: {
                cancel: false
            },
            onDestroy() {
                window.location.reload();
            }
        });
    }
}
